export const dstInitialState = {
    allPCs: [],
    allTrainers: [],
    numberOfFilters: 0,
    trainerList: [],
    trainerListBeforeFilters: [],
    searchedPcList: [],
    searchedTrainerList: [],
    searchedTrainerListBeforeFilters: []
};